import { CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "./FilterAgentSearch.scss";
import { PropertyApi } from "../../../../../utils/api/Property";
import { getAgentId, getImageUrl } from "../../../../../utils/helpers/common";
import SearchIcon from "../../../../../components/icons/SearchIcon";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";
import CloseIcon from "../../../../../components/icons/CloseIcon";

const FilterAgentSearch = ({ formik }: { formik: any }) => {
  const [state, setState] = useState({
    agentListBox: false,
    agentsList: [],
    isLoading: true,
  });

  const boxRef = useRef<HTMLDivElement>(null);

  const onToggelBox = () => {
    setState({
      ...state,
      agentListBox: !state?.agentListBox,
    });
  };

  const onClickSelect = (id: string) => {
    if (formik?.values?.selectedAgentIds?.length) {
      formik.setFieldValue("selectedAgentIds", [
        ...formik?.values?.selectedAgentIds,
        id,
      ]);
      setState({
        ...state,
        agentListBox: !state?.agentListBox,
      });
    } else {
      formik.setFieldValue("selectedAgentIds", [id]);
      setState({
        ...state,
        agentListBox: !state?.agentListBox,
      });
    }
  };

  const onClickRemove = (id: string) => {
    const result = formik?.values?.selectedAgentIds.filter(
      (_id: string) => _id !== id
    );

    formik.setFieldValue("selectedAgentIds", result);
  };

  const getDataApi = async () => {
    setState({
      ...state,
      isLoading: true,
    });
    let res = await PropertyApi.getAgents();

    if (res?.data?.success) {
      const filterResult = res?.data?.data?.docs.filter(
        (data: any) => data?.id !== getAgentId()
      );
      setState({
        ...state,
        isLoading: false,
        agentsList: filterResult,
      });
    } else {
      setState({
        ...state,
        isLoading: false,
      });
      toast.error(res?.data?.message);
    }
  };

  const agentCheck = (id: string) => {
    return formik?.values?.selectedAgentIds?.includes(id);
  };

  useEffect(() => {
    getDataApi();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(event.target as Node)) {
        setState((prev) => ({
          ...prev,
          agentListBox: false,
        }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={boxRef} className="agent-contain-container">
      <div className="agent-heading">
        <p>Agent</p>
      </div>

      <div className="filter-search-agent">
        <div className="filter-search-icon">
          <SearchIcon />
        </div>
        <input
          type="text"
          placeholder="Search Or Select Agent"
          className="filter-search-input"
          onClick={onToggelBox}
        />
        <div
          className={`filter-down-arrow-icon ${
            state?.agentListBox ? "open-box" : ""
          }`}
          onClick={onToggelBox}
        >
          {state?.isLoading ? (
            <CircularProgress
              style={{
                width: 20,
                height: 20,
                color: "black",
                marginTop: "-2px",
              }}
            />
          ) : (
            <DownArrowIcon />
          )}
        </div>
      </div>
      <div className="selected-agent-contain">
        {state?.agentsList?.map((data: any) => {
          if (agentCheck(data?._id)) {
            return (
              <div className={`selected-agent`} key={data?._id}>
                <div className="selected-agent-profile-details">
                  <div className="selected-agent-profile-img">
                    <img
                      src={getImageUrl(
                        data?.profile_image_ref?.compressed_file_path
                      )}
                      alt=""
                    />
                  </div>

                  <p className="selected-agent-profile-name">{`${data?.principal_agent_first_name} ${data?.principal_agent_last_name}`}</p>
                </div>
                <div
                  className="selected-agent-remove-icon"
                  onClick={() => onClickRemove(data?._id)}
                >
                  <CloseIcon />
                </div>
              </div>
            );
          }
        })}
      </div>

      <div
        className={`agent-list-container ${
          state?.agentListBox ? "" : "display-none"
        }`}
      >
        {state?.agentsList?.length ? (
          state?.agentsList?.map((data: any) => (
            <div
              className={`agent-list-item ${
                agentCheck(data?._id) ? "agent-list-item-active" : ""
              }`}
              key={data?._id}
              onClick={() => onClickSelect(data?._id)}
            >
              <div className="item-profile-img">
                <img
                  src={getImageUrl(
                    data?.profile_image_ref?.compressed_file_path
                  )}
                  alt=""
                />
              </div>
              <p className="item-profile-name">{`${data?.principal_agent_first_name} ${data?.principal_agent_last_name}`}</p>
            </div>
          ))
        ) : (
          <div className="agent-list-not-found">
            <p>Agents not found!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterAgentSearch;
